import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class UsefulService {
  cnpj: any;
  strCNPJ: any;

  constructor(
    public alertController: AlertController,
    public modalController: ModalController,
    public http: HttpClient,
    public toast: ToastService,
    private datePipe: DatePipe,
  ) { }


  formatDate(value) {
    let date = this.datePipe.transform(value, 'y-MM-d');
    return date;
  }

  updateBrokenUrl(event) {
    event.target.src = "assets/img/broken.jpg";
    event.target.alt = "Image not broken/found";
  }

  cleanStr(string) {
    let newStr = string.replace(/\s/g, '').replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, '');
    return newStr;
  }

  async fileChangeInsertImg(event) {
    //v.2 edited edn9
    return new Promise((resolve) => {
      let lstImg = [];
      let lstNames = [];

      if (event.target.files && event.target.files[0]) {
        Array.from(event.target.files).forEach((img, index) => {

          let reader = new FileReader();

          reader.onload = async (image: any) => {
            let imagem = new Image();
            imagem.src = image.target.result;

            let imageName = img['name'].split('.')[0];
            let imageType = img['type'];
            let resizedImageName = img['name'].split('.')[0];

            //old image kb size
            this.checkKbImg(imagem.src, img['name'].split('.')[0]).then((res) => {
              let imageSizeKb = res;
            });


            imagem.onload = () => {

              //old image width x height size
              let imageDisplay = imagem.width + 'x' + imagem.height;

              let nome = event.target.files[index].name.split(".")[0];
              let url = nome.replace(/ /gi, "_");

              this.resizeImg(image.target.result, 1200 / 3, 1200 / 3, 0.5, imageType, f => {

                this.checkKbImg(f, url.split('.')[0]).then((res) => {
                  //new image kb size
                  let resizedImageSizeKb = res;
                });
                lstImg.push(f);
                lstNames.push(imageName);
                if (index + 1 == event.target.files.length) {
                  let data = [];
                  data.push(lstImg);
                  data.push(lstNames);
                  resolve(data);
                }

              });
            }

          }

          reader.readAsDataURL(event.target.files[index]);
        });
      }
    });
  }

  resizeImg(img, MAX_WIDTH: number = 1200, MAX_HEIGHT: number = 1200, quality: number = 1, type, callback) {
    //v.2 edited edn9
    var canvas: any = document.createElement("canvas");
    var image = new Image();

    image.onload = () => {
      var width = image.width;
      var height = image.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");

      ctx.drawImage(image, 0, 0, width, height);

      //new width x height size
      let resizedImgDisplay = Math.round(width) + 'x' + Math.round(height);

      var dataUrl = canvas.toDataURL(type, quality);
      let resizedImageType = type;

      callback(dataUrl);
    }
    image.src = img;
  }

  checkKbImg(img, name) {
    //v.2 edited edn9
    return this.urltoFile(img, name, 'text/plain')
      .then((file) => {

        return Math.floor(file.size / 1024);
      });
  }

  urltoFile(url, filename, mimeType) {
    //v.2 edited edn9
    return (fetch(url)
      .then((res) => { return res.arrayBuffer(); })
      .then((buf) => { return new File([buf], filename, { type: mimeType }); })
    );
  }

  handleCEP(e) {
    return new Promise((resolve, reject) => {
      this.http.get('https://viacep.com.br/ws/' + e + '/json/?callback')
        .subscribe((result: any) => {
          resolve(result);
        },
          (error) => {
            this.toast.danger('CEP INVÁLIDO - Digite um CEP válido');
            reject(error);
          });
    });
  }

  async copyToClipboard(value) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    const alertCopy = await this.alertController.create({
      message: 'Link copiado para área de transferência!',
      translucent: true,
      cssClass: 'alertMessage',
    });

    alertCopy.present();
  }

  handleCpf(cpf: string): boolean {
    var cpf = cpf.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

    if (cpf == null) {
      this.cpfAlert();
      return false;
    }
    if (cpf.length != 11) {
      this.cpfAlert();
      return false;
    }
    if ((cpf == '00000000000') || (cpf == '11111111111') || (cpf == '22222222222') || (cpf == '33333333333') || (cpf == '44444444444') || (cpf == '55555555555') || (cpf == '66666666666') || (cpf == '77777777777') || (cpf == '88888888888') || (cpf == '99999999999')) {
      this.cpfAlert();
      return false;
    }
    let numero: number = 0;
    let caracter: string = '';
    let numeros: string = '0123456789';
    let j: number = 10;
    let somatorio: number = 0;
    let resto: number = 0;
    let digito1: number = 0;
    let digito2: number = 0;
    let cpfAux: string = '';
    cpfAux = cpf.substring(0, 9);
    for (let i: number = 0; i < 9; i++) {
      caracter = cpfAux.charAt(i);
      if (numeros.search(caracter) == -1) {
        this.cpfAlert();
        return false;
      }
      numero = Number(caracter);
      somatorio = somatorio + (numero * j);
      j--;
    }
    resto = somatorio % 11;
    digito1 = 11 - resto;
    if (digito1 > 9) {
      digito1 = 0;
    }
    j = 11;
    somatorio = 0;
    cpfAux = cpfAux + digito1;
    for (let i: number = 0; i < 10; i++) {
      caracter = cpfAux.charAt(i);
      numero = Number(caracter);
      somatorio = somatorio + (numero * j);
      j--;
    }
    resto = somatorio % 11;
    digito2 = 11 - resto;
    if (digito2 > 9) {
      digito2 = 0;
    }
    cpfAux = cpfAux + digito2;
    if (cpf != cpfAux) {
      this.cpfAlert();
      return false;
    }
    else {
      return true;
    }
  }

  async cpfAlert() {
    const alert = await this.alertController.create({
      header: 'CPF Inválido!',
      message: 'Digite um número de CPF válido para prosseguir',
      buttons: ['OK']
    });
    await alert.present();
  }

  async cpfAlertHasCompany() {
    const alert = await this.alertController.create({
      header: 'CPF já cadastrado!',
      message: 'CPF já cadastrado em outra empresa.',
      buttons: ['OK']
    });
    await alert.present();
  }

  //Função que irá testar se o CNPJ é valido 
  handleCnpj(e) {
    this.cnpj = e;
    // Verifica se a variável cnpj é igua a "undefined", exibindo uma msg de erro
    if (this.cnpj === undefined) {
      this.cnpjAlert();
      return false;
    }

    // Esta função retira os caracteres . / - da string do cnpj, deixando apenas os números 
    var strCNPJ = this.cnpj.replace('.', '').replace('.', '').replace('/', '').replace('-', '');

    // Testa as sequencias que possuem todos os dígitos iguais e se o cnpj não tem 14 dígitos, retonando falso e exibindo uma msg de erro
    if (strCNPJ === '00000000000000' || strCNPJ === '11111111111111' || strCNPJ === '22222222222222' || strCNPJ === '33333333333333' ||
      strCNPJ === '44444444444444' || strCNPJ === '55555555555555' || strCNPJ === '66666666666666' || strCNPJ === '77777777777777' ||
      strCNPJ === '88888888888888' || strCNPJ === '99999999999999' || strCNPJ.length !== 14) {
      this.cnpjAlert();
      return false;
    }

    // A variável numeros pega o bloco com os números sem o DV, a variavel digitos pega apenas os dois ultimos numeros (Digito Verificador).
    var tamanho = strCNPJ.length - 2;
    var numeros = strCNPJ.substring(0, tamanho);
    var digitos = strCNPJ.substring(tamanho);
    var soma = 0;
    var pos = tamanho - 7;

    // Os quatro blocos seguintes de funções irá reaizar a validação do CNPJ propriamente dito, conferindo se o DV bate. Caso alguma das funções não consiga verificar
    // o DV corretamente, mostrará uma mensagem de erro ao usuário e retornará falso, para que o usário posso digitar novamente um número 
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      this.cnpjAlert();
      return false;
    }

    tamanho = tamanho + 1;
    numeros = strCNPJ.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let k = tamanho; k >= 1; k--) {
      soma += numeros.charAt(tamanho - k) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      this.cnpjAlert();
      return false;
    }

    this.update();
    return true;
  }

  //Caso o CNPJ será valido, irá realizar a gravação do mesmo na variável strCNPJ
  async update() {
    await this.modalController.dismiss(this.strCNPJ);
  }

  //Exibe uma mensagem de alerta ao usuário, caso o número do CNPJ seja inválido
  async cnpjAlert() {
    //console.log('CNPJ Inválido! Digite um número de CNPJ válido para prosseguir.')
    const alert = await this.alertController.create({
      header: 'CNPJ Inválido!',
      message: 'Digite um número de CNPJ válido para prosseguir',
      buttons: ['OK']
    });
    await alert.present();
  }

  async cnpjAlertHasCompany() {
    const alert = await this.alertController.create({
      header: 'CNPJ já cadastrado!',
      message: 'CNPJ já cadastrado em outra empresa.',
      buttons: ['OK']
    });
    await alert.present();
  }
}
